var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11500_92399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0814 5.586L0.900375 18.769C0.358794 19.3497 0.0638166 20.118 0.0776114 20.912C0.0914062 21.7059 0.412896 22.4635 0.974324 23.0251C1.53575 23.5866 2.29327 23.9083 3.08721 23.9223C3.88116 23.9362 4.64953 23.6415 5.23037 23.1L18.4144 9.919L14.0814 5.586ZM15.5864 9.919L13.0004 12.505L11.5004 11L14.0864 8.414L15.5864 9.919ZM3.81638 21.688C3.61422 21.8807 3.34566 21.9882 3.06638 21.9882C2.78709 21.9882 2.51853 21.8807 2.31638 21.688C2.11779 21.4889 2.00627 21.2192 2.00627 20.938C2.00627 20.6568 2.11779 20.3871 2.31638 20.188L10.0854 12.418L11.5904 13.923L3.81638 21.688ZM21.3334 14.628L24.0004 15.962L21.3334 17.3L20.0004 19.962L18.6674 17.3L16.0004 15.962L18.6674 14.628L20.0004 11.962L21.3334 14.628ZM6.66737 5.333L4.00038 4L6.66737 2.667L8.00037 0L9.33337 2.667L12.0004 4L9.33337 5.333L8.00037 8L6.66737 5.333ZM19.3334 4.667L17.0004 3.5L19.3334 2.333L20.5004 0L21.6674 2.333L24.0004 3.5L21.6674 4.667L20.5004 7L19.3334 4.667Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11500_92399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.42abca8755ec0fcbdd4e3359045f804e.svg";
export { ForwardRef as ReactComponent };